import Vue from "vue";
import Router from "vue-router";
import store from "./store/store";
import Home from "./views/Home";
import BatchHistory from "./views/BatchHistory";
import BatchDetails from "./views/BatchDetails";
import Login from "./views/SignIn";
import axios from "axios";


Vue.use(Router);

function getUser() {
  return Vue.prototype.$Amplify.Auth.currentAuthenticatedUser()
    .then((data) => {
      if (data && data.signInUserSession) {
        store.commit("setUser", data);

        return data;
      }
    })
    .catch((e) => {
      store.commit("setUser", null);
      return null;
    });
}

export const router = new Router({
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "/sso-login",
      component: Login,
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "/batch-history",
      component: BatchHistory,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/batch/:batchId",
      component: BatchDetails,
      meta: {
        requiresAuth: true,
      },
      props:true,
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return {
        x: 0,
        y: 0,
      };
    }
  },
});

router.beforeResolve(async (to, from, next) => {

  //Check first if page requires auth:
  if (to.matched.some((record) => record.meta.requiresAuth)) {

    //Is Auth session UUID set in memory? If so, just show the page right away
    if(store.getters['auth/isSignedIn']) {
      return next();
    }

    // If Auth session UUID is not set in memory, do these procedures:
    else {

      // Try to refresh token first:
      console.log(`[router] Trying refresh token procedure now... ${store.state.apiUrl}/refresh`);

      store.commit('auth/managingSessions', true);

      const newSessionToken = await axios.post(
        `${store.state.apiUrl}/refresh`,
        {},
        {
          withCredentials: true //important for the refresh cookie to be sent
        }
      ).then((rslt)=>{
        console.log(`[router] Refresh succeeded: + ${JSON.stringify(rslt)}`);

        store.commit('auth/managingSessions', false);

        return rslt.data.sessionToken;
      }).catch(err => {
        console.log(`[router] Refresh failed: + ${err}: ${err.response.data.message}`);
        return false;
      });


     //If refresh succeeded, we set the returned session token
      // as the new session token then proceed to the page. Yay!
      if(newSessionToken) {
        store.dispatch("auth/updateSessionToken", {newSessionToken});
        return next();
      }

      // If Refresh didn't succeed, try to silent login to AD.
      // Then ultimately, if that fails, just redirect to /sso-login to login to AD manually,
      // so we can get a new session UUID from our endpoint
      else {
        //Just an added check to see if logging in is progress, return back to
        // the login page right away instead of doing another silent sign in
        if(await store.dispatch("auth/getLoginInProgress")){
          console.log(`[router to ${to.path}] Login is in progress. Redirecting back to login page.`);
          store.commit("auth/signInFailed");
          return next("/sso-login");
        }

        store.dispatch("auth/silentSignIn")
          .then(response => {
            console.log(`[router to ${to.path}] Silent sign-in successful:`);
            return next();
          })
          .catch(error => {
            console.log(`[router to ${to.path}] silentSignIn catch:`, error);
            return next("/sso-login");
          })

      }
    }

  }

  //If no auth required, just show the page as is:
  else {

    //Though... if accessing the login page but still have Auth session in memory, redirect right away to Batch History page
    if ((to.path == '/sso-login') && (store.getters['auth/isSignedIn'])) {
      return next('/batch-history');
    }

    return next();
  }



});

export default router;
